export const printer = (htmlToPrint: string) => {
  const WinPrint = window.open()
  WinPrint?.document.write(htmlToPrint)
  WinPrint?.document.close()
  // sometimes the SVG's don't render in time, delay for a complete render
  WinPrint?.addEventListener('load', () => {
    setTimeout(() => {
      WinPrint?.focus()
      WinPrint?.print()
      WinPrint?.close()
    }, 300)
  })
}

export const styleDocForPrinting = (html: string) => {
  const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map(el => el.outerHTML)
      .join('\n')

    return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  ${styles}
</head>
<body>
  ${html}
</body>
</html>
`
}
